<div fxLayout="column" ngStyle.lt-md="padding: 0 1rem;">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else noteDisbursementScheduleListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="noteDisbursementScheduleListFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #noteDisbursementScheduleListFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
      <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxLayout="column" *ngIf="!showSpinner">
      <div *ngIf="isBrowserIE; else noteDisbursementScheduleListTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="noteDisbursementScheduleListTableFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noteDisbursementScheduleListTableFlexColumnTemplate>
  <div fxFlex="100%" class="display-text primary-dark-color-important">
    <b><span i18n="@@note-disbursement-schedule-list.table.title">note-disbursement-schedule-list.table.title</span></b>
  </div>

  <div fxFlex="100%" class="display-text title-spacer" *ngIf="!notesDisbursementScheduleListFound">
    <i><span i18n="@@note-disbursement-schedule-list.table.no-records">note-disbursement-schedule-list.table.no-records</span></i>
  </div>

  <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
    <mat-table #table [dataSource]="tableDataSource" class="primary-lightest-bg" ngClass.lt-md="small-table-text">
      <!-- scheduledDisbursementDate Column -->
      <ng-container matColumnDef="scheduledDisbursementDate">
        <mat-header-cell *matHeaderCellDef fxFlex="30%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-disbursement-schedule-list.table.column-header.scheduled-disbursement-date"
            >note-disbursement-schedule-list.table.column-header.scheduled-disbursement-date</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="30%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.scheduledDisbursementDate | date: 'MM/dd/yyyy'
        }}</mat-cell>
      </ng-container>
      <!-- grossDisbursementAmount Column -->
      <ng-container matColumnDef="grossDisbursementAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="30%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-disbursement-schedule-list.table.column-header.gross-disbursement-amount"
            >note-disbursement-schedule-list.table.column-header.gross-disbursement-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="30%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.grossDisbursementAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- disbursementStatus Column -->
      <ng-container matColumnDef="disbursementStatus">
        <mat-header-cell *matHeaderCellDef fxFlex="40%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-disbursement-schedule-list.table.column-header.disbursement-status"
            >note-disbursement-schedule-list.table.column-header.disbursement-status</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="40%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.disbursementStatus
        }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="tableDisplayedColumns" ngClass.lt-md="small-header-row"></mat-header-row>
      <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"></mat-row>
    </mat-table>
  </div>
  <div fxFlex="100%" fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="notesDisbursementScheduleListFound">
    <app-table-record-count
      [recordCount]="notesDisbursementScheduleList.length"
      i18n-singularLabel="@@note-disbursement-schedule-list.table.record-count.singular-label"
      singularLabel="note-disbursement-schedule-list.table.record-count.singular-label"
      i18n-multipleLabel="@@note-disbursement-schedule-list.table.record-count.multiple-label"
      multipleLabel="note-disbursement-schedule-list.table.record-count.multiple-label"
    ></app-table-record-count>
  </div>
</ng-template>
